<template>
    <p class="fedex-disclaimer mt-3 mb-0 text-muted">
        The FedEx service marks are owned by Federal Express Corporation and are used by permission.
    </p>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

/** Required verbatim by FedEx Integrator AGD 3c on every screen showing a FedEx mark or service name. */
@Component({ name: "FedExDisclaimer" })
export default class FedExDisclaimer extends Vue {
}
</script>

<style scoped>
.fedex-disclaimer {
    /* Pinned in pt so a parent rem scale cannot drop it under the AGD 8pt floor. */
    font-size: 9pt;
    font-style: italic;
    text-align: center;
}
</style>
